import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
	PURCHASE_INDENTS_LIST,
	VENDORS_LIST,
	GET_VENDORS_DATA,
	REQUESTFORQUOTATION_ADD,
	RFQ_LIST,
	RFQ_LIST_COUNT,
	RFQ_ROW_DATA,
	RF_MODEL_LIST_OPEN,
	GENERATE_RFQ_PDF,
	FILTERS_SHOW_RIGHT_SIDEBAR,
	FILTERS_HIDE_RIGHT_SIDEBAR,
	ADD_VENDORS,
	MR_CODE_DETAILS,
	PI_DETAILS_MODEL_OPEN,
	MR_ITEM_IMAGES,
	RFQ_PI_ITEM_CANCEL,
} from "./actionTypes";
import {
	apiError,
	getPuchaseIndentItemsSuccessful,
	VendorsListSuccessful,
	VendorDataSuccessful,
	RFQRequestListSuccessful,
	getRFQRequestdata,
	getRFQRequestdataSuccessful,
	downloadRFQButton,
	getMRCodeDetailsSuccessful,
	PIRowDataSuccessful,
	RFQListCountSuccessful,
	getMRItemImgesSuccessful,
	getPurchaseIndentItems,
} from "./actions";

import {
	postAdd,
	getList,
	getParamsList,
	getDownloadFile,
	postEdit,
	// postEdit,
	// postDelete,
} from "../../helpers/Helper";
import swal from "sweetalert";
import Swal from "sweetalert2";
import moment from "moment";

function* getPurchaseIndentsList({ payload: { data } }) {
	var params = {};
	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "picurrentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.picurrentSort;
			} else {
				if (data[k] !== "" && k !== "no_of_pages") {
					if (k === "start_date") {
						params[k] = moment(data[k]).format("YYYY-MM-DD");
					} else if (k === "end_date") {
						params[k] = moment(data[k]).format("YYYY-MM-DD");
					} else if (k == "month") {
						params[k] = moment(data[k]).format("MM-YYYY");
					} else {
						params[k] = data[k];
					}
				}
			}
		}
	}
	try {
		const response = yield call(
			getParamsList,
			"/purchaseindent/rfqlistitem",
			params
		);
	
		yield put(getPuchaseIndentItemsSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getSelectedProductVendorsList({ payload: { data } }) {
	var params = {};

	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (data[k] !== "") {
				params[k] = data[k];
			}
		}
	}
	try {
		const response = yield call(
			getParamsList,
			"/masters/mini/vendors/",
			params
		);
		// const response = yield call(
		//   postAdd,
		//   "/masters/mini/vendors/byproducts",
		//   data
		// );
		yield put(VendorsListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* GetVendorData({ payload: { VendId } }) {
	try {
		const response = yield call(getList, "/masters/vendors/" + VendId, {});
		yield put(VendorDataSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* RequestForQuotationAdd({ payload: { data } }) {
	try {
		const response = yield call(postAdd, "/requestforquotation/", data);

		if (response.status === 201) {
			swal("Your Request Added Successfully.!", {
				icon: "success",
			});
			yield put(downloadRFQButton(response.data.id));
		} else {
			swal("Sorry! Unable to ad Request. Please Try Again!", {
				icon: "error",
			});
		}
	} catch (error) {
		swal(error[0], {
			icon: "error",
		});
	}
}
function* getRFQList({ payload: { data } }) {
	var params = {};
	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "rfqstatus") {
				if (data.rfqstatus[0] !== 0) {
					params.rfqstatus = data.rfqstatus.join(",");
				}
			} else if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "" && k !== "no_of_pages") {
					if (k === "start_date") {
						params[k] = moment(data[k]).format("YYYY-MM-DD");
					} else if (k === "end_date") {
						params[k] = moment(data[k]).format("YYYY-MM-DD");
					} else if (k == "month") {
						params[k] = moment(data[k]).format("MM-YYYY");
					} else {
						params[k] = data[k];
					}
				}
			}
		}
	}
	try {
		const response = yield call(
			getParamsList,
			"/requestforquotation/list",
			params
		);
		yield put(RFQRequestListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getRFQListCount({ payload: { data } }) {
	var params = {};

	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "rfqstatus") {
				if (data.rfqstatus[0] !== 0) {
					params.rfqstatus = data.rfqstatus.join(",");
				}
			} else if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "" && k !== "no_of_pages") {
					params[k] = data[k];
				}
			}
		}
	}

	try {
		const response = yield call(
			getParamsList,
			"/requestforquotation/count/list",
			params
		);

		yield put(RFQListCountSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getRFQRowdata({ payload: { rfqId } }) {
	try {
		const response = yield call(
			getList,
			"/requestforquotation/" + rfqId,
			{}
		);
		yield put(getRFQRequestdataSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* AddVendorsData({ payload: { data, rfqId } }) {
	try {
		const response = yield call(
			postEdit,
			"/requestforquotation/addvendors/" + rfqId,
			data
		);
		if (response.status === 200) {
			swal(" Vendors Added Successfully.!", {
				icon: "success",
			});
			yield put(getRFQRequestdata(rfqId));
		} else {
			swal("Sorry! Unable to add Vendors. Please Try Again!", {
				icon: "error",
			});
		}
	} catch (error) {
		yield put(apiError(error));
		Swal.fire({
			icon: "error",
			text: "Sorry! Vendor is not allowed in Resend RFQ",
		});
	}
}
function* GetPIDetails({ payload: { PIID } }) {
	try {
		const response = yield call(getList, "/purchaseindent/" + PIID, {});
		yield put(PIRowDataSuccessful(response));
	} catch (error) {
		yield put(PIRowDataSuccessful(null));
		swal("Error in getting PI data from the Server", {
			icon: "error",
		});
	}
}
function* getMRCodeDetails({ payload: { ItemId } }) {
	try {
		const response = yield call(
			getList,
			"/requestforquotation/mrcodebyrfqitem/" + ItemId,
			{}
		);
		yield put(getMRCodeDetailsSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* generateRFQPDF({ payload: { RFQId } }) {
	try {
		yield call(getDownloadFile, "/requestforquotation/pdf/" + RFQId);

		// generateRFQasPDF("RFQ",response)
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getPIMRItemImges({ payload: { PIItemId } }) {
	try {
		const response = yield call(
			getList,
			"/purchaseindent/mrcodebypiitem/" + PIItemId,
			{}
		);
		yield put(getMRItemImgesSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* PIItemCancel({ payload: { data } }) {
	try {
		const response = yield call(
			postAdd,
			"/purchaseindent/purchaseuserapprove",
			data
		);

		if (response.status === 201) {
			if (data.pistatus === 10) {
				swal(
					" Your Purchase Indent Item has been Cancle sucessfully!",
					{
						icon: "success",
					}
				);
			}

			yield put(getPurchaseIndentItems({ page: 1 }));
		} else {
			swal(" Sorry! Your Purchase Indent Item has been not changed!", {
				icon: "success",
			});
		}
	} catch (error) {
		swal("Sorry! Error in getting from the Server", {
			icon: "error",
		});

		yield put(apiError(error));
	}
}

/**
 * CProduct the class on body
 * @param {*} cssClass
 */
function manageBodyClass(cssClass, action = "toggle") {
	switch (action) {
		case "add":
			if (document.body) document.body.classList.add(cssClass);
			break;
		case "remove":
			if (document.body) document.body.classList.remove(cssClass);
			break;
		default:
			if (document.body) document.body.classList.toggle(cssClass);
			break;
	}

	return true;
}
function* FilterShowRightSidebar() {
	try {
		yield call(manageBodyClass, "filters-right-bar-enabled");
	} catch (error) {}
}
function* FilterHideRightSidebar() {
	try {
		yield call(manageBodyClass, "filters-right-bar-enabled", "remove");
	} catch (error) {}
}
export function* watchgetPurcahseIndentList() {
	yield takeEvery(PURCHASE_INDENTS_LIST, getPurchaseIndentsList);
}
export function* watchgetSelectedProductVendors() {
	yield takeEvery(VENDORS_LIST, getSelectedProductVendorsList);
}
export function* watchGetVendorData() {
	yield takeEvery(GET_VENDORS_DATA, GetVendorData);
}
export function* watchRequestForQuotationAdd() {
	yield takeEvery(REQUESTFORQUOTATION_ADD, RequestForQuotationAdd);
}
export function* watchgetRFQList() {
	yield takeEvery(RFQ_LIST, getRFQList);
}
export function* watchgetRFQCount() {
	yield takeEvery(RFQ_LIST_COUNT, getRFQListCount);
}
export function* watchgetRFQRowdata() {
	yield takeEvery(RFQ_ROW_DATA, getRFQRowdata);
}
export function* watchmodellist() {
	yield takeEvery(RF_MODEL_LIST_OPEN, getRFQRowdata);
}
export function* watchgenerateRFQPDF() {
	yield takeEvery(GENERATE_RFQ_PDF, generateRFQPDF);
}
export function* watchFilterShowRightSidebar() {
	yield takeEvery(FILTERS_SHOW_RIGHT_SIDEBAR, FilterShowRightSidebar);
}
export function* watchfilterHideRightSidebarr() {
	yield takeEvery(FILTERS_HIDE_RIGHT_SIDEBAR, FilterHideRightSidebar);
}
export function* watchAddVendors() {
	yield takeEvery(ADD_VENDORS, AddVendorsData);
}
export function* watchGetPIDetails() {
	yield takeEvery(PI_DETAILS_MODEL_OPEN, GetPIDetails);
}
export function* watchgetMRCodeDetails() {
	yield takeEvery(MR_CODE_DETAILS, getMRCodeDetails);
}
export function* watchgetMRItemData() {
	yield takeEvery(MR_ITEM_IMAGES, getPIMRItemImges);
}
export function* watchPIItemCancel() {
	yield takeEvery(RFQ_PI_ITEM_CANCEL, PIItemCancel);
}
function* RequestForQuotationSaga() {
	yield all([
		fork(watchgetPurcahseIndentList),
		fork(watchgetSelectedProductVendors),
		fork(watchGetVendorData),
		fork(watchgetRFQList),
		fork(watchgetRFQRowdata),
		fork(watchgenerateRFQPDF),
		fork(watchmodellist),
		fork(watchAddVendors),
		fork(watchgetRFQCount),
		fork(watchRequestForQuotationAdd),
		fork(watchFilterShowRightSidebar),
		fork(watchfilterHideRightSidebarr),
		fork(watchGetPIDetails),
		fork(watchgetMRCodeDetails),
		fork(watchgetMRItemData),
		fork(watchPIItemCancel),
	]);
}

export default RequestForQuotationSaga;
